import React from 'react';
// import PageInfoStore from './flux/PageInfoStore';
// import MainSubNav from './MainSubNav';
// import MainNavButtons from './MainNavButtons';

export default function Image(props) {
  const media = props.media;
  // console.log(media);
  // console.log(media.width);
  // console.log(media.height);
  
  return (
    <img
      className="image"
      // sizes="(min-width: 1600px) 960, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
      // srcSet={media.images.map((variant) => {
      //   return `${variant.src} ${variant.size}w,`;
      // })}
      src={media.src}
      loading="lazy"
      alt={media.alt}
      // width={`${media.width}px`}
      // height={`${media.height}px`}
    />
  );
}